export { load } from '@telerik/kendo-intl';
//# sourceMappingURL=coreExports.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-intl/dist/es/coreExports.js
// module id = 1149
// module chunks = 0